import type { IssueReportOffer } from '@/lib/types/billing';
import { ISSUE_REPORT_OFFER_ENDPOINT } from '@/lib/constants/issue-report';
import { apiClient } from './client';

/**
 * The current Issue Report offer (FR-201). `@Public()` on the Backend, so it
 * works with or without a session. Cross-feature: the public Due Diligence
 * page, the navbar, the dashboard, the Data Room and the purchase journey all
 * read this one resource, so they cannot disagree about price or availability.
 * Rejects on a failed request; `coming_soon` is a normal 200 result.
 */
export async function getIssueReportOffer(): Promise<IssueReportOffer> {
  const { data } = await apiClient.get<IssueReportOffer>(ISSUE_REPORT_OFFER_ENDPOINT);
  return data;
}
